<div class="s-section__btn" style="text-align: center">
  <a [href]="(component.content.fileData | file:component.content.fileType)" target="_blank" class="c-btn is-primary">
    {{component.content.title || component.content.originalName}}
  </a>
</div>
